import { Converter } from '../types/converter';

export const linearCurrentDensityConverter: Converter = {
  id: 'linearCurrentDensity',
  name: 'Linear Current Density Converter',
  icon: 'MinusSquare',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Ampere/meter', symbol: 'A/m', factor: 1 },
    { name: 'Ampere/centimeter', symbol: 'A/cm', factor: 100 },
    { name: 'Ampere/inch', symbol: 'A/in', factor: 39.37007874 },
    
    // CGS units
    { name: 'Abampere/meter', symbol: 'abA/m', factor: 10 },
    { name: 'Abampere/centimeter', symbol: 'abA/cm', factor: 1000 },
    { name: 'Abampere/inch', symbol: 'abA/in', factor: 393.7007874 },
    
    // Other units
    { name: 'Oersted', symbol: 'Oe', factor: 79.5774715459477 },
    { name: 'Gilbert/centimeter', symbol: 'Gi/cm', factor: 79.5774715459477 }
  ]
};
